import { ORDER } from './schema';

export const ENTITIES = 'entities';

export default {
  [ENTITIES]: {},
  [ORDER]: [],
  statuses: [],
  substitutionOptions: [],
  currentOrder: {},
  ordersParams: {},
  filters: {},
  paginationOptions: {}
};
